export const convertBase64UrlToBlob = function (dataUrl) {
  let bytes = window.atob(dataUrl.split(',')[1]);
  let ab = new Uint8Array(bytes.length);
  for (let i = 0; i < bytes.length; i++) {
    ab[i] = bytes.charCodeAt(i);
  }
  return new Blob([ab], {type: 'image/png'});
};

export const dateFormat2 = function (time) {
  if(!time) return ''
  let date = new Date(Number(time));
  if(!date) return ''
  let str = `${date.getMonth() + 1}月${date.getDate()}日`;
  const hour = date.getHours() + 1 > 10 ? date.getHours() : '0' + String(date.getHours())
  const minutes = date.getMinutes() + 1 > 10 ? date.getMinutes() : '0' + String(date.getMinutes())
  return `${str}${hour}:${minutes}`;
};

export const dateFormat3 = function (time) {
  if(!time) return ''
  let date = new Date(Number(time));
  if(!date) return ''
  return `${date.getDate()}/${date.getMonth() + 1}`;
};

export const dateFormat = function (time, flag = false) {
  if(!time) return
  let date = new Date(time);
    const month = date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : '0' + String(date.getMonth() + 1)
    const day = date.getDate() >= 10 ? date.getDate() : '0' + String(date.getDate())
  let str = `${date.getFullYear()}-${month}-${day}`;
  const hour = date.getHours() >= 10 ? date.getHours() : '0' + String(date.getHours())
  const minutes = date.getMinutes() >= 10 ? date.getMinutes() : '0' + String(date.getMinutes())
  const second = date.getSeconds() >= 10 ? date.getSeconds() : '0' + String(date.getSeconds())
  if (!flag) {
    return str;
  }
  // return `${str} ${hour}:${minutes}:${second}`;
  return `${str} ${hour}:${minutes}`;
};
export const formatSecondsToMMSS = function (seconds) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  // 使用padStart来保证分钟和秒都是两位数，不足两位前面补0
  const formattedMinutes = ('0' + minutes).slice(-2);
  const formattedSeconds = ('0' + remainingSeconds).slice(-2);

  return `${formattedMinutes}:${formattedSeconds}`;
}
export const dateDeadlineFormat = function (time, flag = false) {
  if(!time) return
    let date = new Date(time);
    let nowDate = new Date()
    const month = date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : '0' + String(date.getMonth() + 1)
    const day = date.getDate() + 1 >= 10 ? date.getDate() : '0' + String(date.getDate())
    const nowmonth = nowDate.getMonth() + 1 >= 10 ? nowDate.getMonth() + 1 : '0' + String(nowDate.getMonth() + 1)
    const nowday = nowDate.getDate() + 1 >= 10 ? nowDate.getDate() : '0' + String(nowDate.getDate())
    let str = `${month}-${day}`;
    if (nowmonth == month && nowday == day && !flag) {
      return '今天'
    }
    return str;

};

export const formatTimestamp = function (timestamp) {
  const date = new Date(timestamp); // JavaScript 中的时间戳是毫秒级的，需要乘以 1000
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const day = ('0' + date.getDate()).slice(-2);
  const hours = ('0' + date.getHours()).slice(-2);
  const minutes = ('0' + date.getMinutes()).slice(-2);

  return `${month}月${day}日 ${hours}:${minutes}`;
}
export const dateRangeFormat = function (startTime,endTime) {
  if(!startTime && !endTime) return ''
  let date1 = ''
  let str1 = ''
  let date2 = ''
  let str2 = ''

    if (startTime) {
        date1 = new Date(Number(startTime));
        const month1 = date1.getMonth() + 1 >= 10 ? date1.getMonth() + 1 : '0' + String(date1.getMonth() + 1)
        const day1 = date1.getDate() + 1 >= 10 ? date1.getDate() : '0' + String(date1.getDate())

        str1 = `${month1}-${day1}`;
    }
  if(endTime) {
      date2 = new Date(Number(endTime));
      const month2 = date2.getMonth() + 1 >= 10 ? date2.getMonth() + 1 : '0' + String(date2.getMonth() + 1)
        const day2 = date2.getDate() + 1 >= 10 ? date2.getDate() : '0' + String(date2.getDate())
    str2 = `${month2}-${day2}`;
  }
  return `${str1}~${str2}`
};

export const getDateDiff = (dateTimeStamp) => {
  var result;
  var minute = 1000 * 60;
  var hour = minute * 60;
  var day = hour * 24;
  var halfamonth = day * 15;
  var month = day * 30;

  var d = new Date(dateTimeStamp); //根据时间戳生成的时间对象
  var g_year = d.getFullYear();
  var g_month = d.getMonth() + 1;
  var g_day = d.getDate();

  if (g_month < 10) {
    g_month = "0" + g_month;
  }
  if (g_day < 10) {
    g_day = "0" + g_day;
  }

  var y_date = g_year.toString().substring(2) + "-" + g_month + "-" + g_day;
  var d_date = g_month + "-" + g_day;

  var now = new Date().getTime();
  var diffValue = now - dateTimeStamp;
  if (diffValue < 0) {
    return;
  }
  var monthC = diffValue / month;
  var weekC = diffValue / (7 * day);
  var dayC = diffValue / day;
  var hourC = diffValue / hour;
  var minC = diffValue / minute;
  if (monthC >= 1) {
    if (monthC <= 12)
      /*  result = "" + parseInt(monthC) + "月前"; */
      result = d_date;
    else {
      /* result = "" + parseInt(monthC / 12) + "年前"; */
      result = y_date;
    }
  } else if (weekC >= 1) {
    /* result = "" + parseInt(weekC) + "周前"; */
    result = d_date;
  } else if (dayC >= 1) {
    if (dayC >= 4) {
      result = d_date;
    } else {
      result = "" + parseInt(dayC) + "天前";
    }
  } else if (hourC >= 1) {
    result = "" + parseInt(hourC) + "小时前";
  } else if (minC >= 1) {
    result = "" + parseInt(minC) + "分钟前";
  } else {
    result = "刚刚";
  }

  return result;
};

//显示截止时间
export const getDateFormat = (dateTimeStamp) => {
  if(!dateTimeStamp) return
  var result;
  var minute = 1000 * 60;
  var hour = minute * 60;
  var day = hour * 24;
  var halfamonth = day * 15;
  var month = day * 30;

  var d = new Date(dateTimeStamp); //根据时间戳生成的时间对象
  var g_year = d.getFullYear();
  var g_month = d.getMonth() + 1;
  var g_day = d.getDate();
  let dayArr = ['周日','周一','周二','周三','周四','周五','周六']
  let dayOfWeek = dayArr[d.getDay()]

  // if (g_month < 10) {
  //   g_month = "0" + g_month;
  // }
  // if (g_day < 10) {
  //   g_day = "0" + g_day;
  // }

  var now = new Date().getTime();
  var now_year = new Date().getFullYear();
  var diffValue = now - dateTimeStamp;

  //本周开始结束时间
  let currentWeek = getCurrentWeekStartTimeAndEndTime()
  let startTime = currentWeek.startTime
  let endTime = currentWeek.endTime

  if (diffValue <= 0) {
    //未来
    if(dateTimeStamp - now <= 7*day) {
      //未来7天内
      if(dateTimeStamp <= endTime) {
        //本周
        result = dayOfWeek
      } else {
        result = '下' + dayOfWeek
      }
    } else {
      if(now_year == g_year) {
        result = `${g_month}月${g_day}日`
      } else {
        result = `${g_year}年${g_month}月${g_day}日`
      }
    }
  } else {
    //过去
    if(now - dateTimeStamp <= 7*day) {
      //过去7天内
      if(dateTimeStamp >= startTime) {
        //本周
        result = dayOfWeek
      } else {
        result = '上' + dayOfWeek
      }
    } else {
      if(now_year == g_year) {
        result = `${g_month}月${g_day}日`
      } else {
        result = `${g_year}年${g_month}月${g_day}日`
      }
    }
  }
  return result;
};

//一天的开始时间
function startTime(time) {
  const nowTimeDate = new Date(time);
  return nowTimeDate.setHours(0, 0, 0, 0);
}

//一天的结束时间
function endTime(time) {
  const nowTimeDate = new Date(time);
  return nowTimeDate.setHours(23, 59, 59, 999);
}

//本周开始结束时间
export const getCurrentWeekStartTimeAndEndTime = function (time) {
  const current = time ? time : new Date();
  // current是本周的第几天
  let nowDayOfWeek = current.getDay();
  if (nowDayOfWeek === 0) nowDayOfWeek = 7;
  const dayNum = 1 * 24 * 60 * 60 * 1000;
  // 获取本周星期一的时间，星期一作为一周的第一天
  const firstDate = new Date(current.valueOf() - (nowDayOfWeek - 1) * dayNum);
  // 获取本周星期天的时间，星期天作为一周的最后一天
  const lastDate = new Date(new Date(firstDate).valueOf() + 6 * dayNum);
  return {
    startTime: new Date(startTime(firstDate)).getTime(),
    endTime: new Date(endTime(lastDate)).getTime(),
  };
}

export const formatTime = (date, flag = true) => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hour = date.getHours();
  const minute = date.getMinutes();
  const second = date.getSeconds();

  if (flag) {
    return (
      [year, month, day].map(formatNumber).join("-") +
      " " +
      [hour, minute, second].map(formatNumber).join(":")
    );
  }
  return [year, month, day].map(formatNumber).join("-");
};

function formatNumber(n) {
  n = n.toString();
  return n[1] ? n : "0" + n;
}



// WEBPACK FOOTER //
// ./src/digitalHuman/tool/transform.js